// File: createRecipe.js (React Component)

import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageHeader1 from "../../components/common/PageHeader1";
import { getFaqByIdApi, submitFaqApi } from "../../services/Faq";
import { idID } from "@mui/material/locale";

function CreateFaq() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editorValue, setEditorValue] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id) {
      (async () => {
        const res = await getFaqByIdApi(id);
        if (res?.data) {
          console.log("Fetched FAQ data:", res.data);
          const r = res.data;
          setValue("question", r.question);
          setValue("answer", r.answer);
        }
      })();
    }
  }, [id, setValue]);

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    };
    if (id) payload._id = id;
    const res = await submitFaqApi(payload);
    if (res) {
      if(!id){
        reset();
      }
      
      
      // if(id) {
      //   navigate("/recipes-list");
      // }
     
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle={id ? "Edit FAQ" : "Add FAQ"}
        navigation="FAQ"
        navlink="/faq-list"
        current={id ? "Edit" : "Add"}
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>{id ? "Edit Recipe" : "Add New Recipe"}</h2>
            </div>

           

            <div className="col-md-6">
              <label className="form-label">Question</label>
              <input
                className="form-control"
                {...register("question", { required: "Question is required" })}
              />
              {errors.title && <p className="text-danger">{errors.question.message}</p>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Answer</label>
              <input
                className="form-control"
                {...register("answer", {
                  required: "Answer is required",
                })}
              />
              {errors.answer && (
                <p className="text-danger">{errors.answer.message}</p>
              )}
            </div>

           
            

            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5 me-3">
                {id ? "Update" : "Save"}
              </Button>
              <Button
                variant="secondary"
                className="px-5"
                onClick={() => navigate("/faq-list")}
              >
                Back
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateFaq;
